var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbBgGreyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb-bg-grey-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "catalogue-desktop",
    transform: "translate(-1189.000000, -1889.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-bg-grey-icon",
    transform: "translate(1189.000000, 1889.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fillOpacity: 0.475897516,
    fill: "#000000",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--brown.fbda7af8775c2a3196af2caac36e1d4d",
    transform: "translate(13.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64956337,21 L6.64956337,10.4987705 L9.6079499,10.4987705 L10,6.87998866 L6.64956337,6.87998866 L6.65458961,5.06875352 C6.65458961,4.12491953 6.7461099,3.61919167 8.12959431,3.61919167 L9.97905714,3.61919167 L9.97905714,0 L7.02025177,0 C3.46625064,0 2.21533437,1.75549852 2.21533437,4.70769502 L2.21533437,6.88039851 L0,6.88039851 L0,10.4991803 L2.21533437,10.4991803 L2.21533437,21 L6.64956337,21 Z",
    id: "Shape-Copy-15"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBgGreyIcon);
export default __webpack_public_path__ + "static/media/fb-bg-grey-icon.1d974ba7ef3014620e4d344b0249da2b.svg";
export { ForwardRef as ReactComponent };